import { type IntlShape, defineMessages } from "react-intl";

import type { HecBadge, HecProduct } from "~/hec/types/product";

const messages = defineMessages({
  added: { id: "spenderGrid.added", defaultMessage: "{count} Added" },
});

/**
 * Replaces a tile's badges. The raw `c_badging` fields are cleared too:
 * `getProductBadges` falls back to them whenever `badges` is empty.
 */
export const withBadges = <P extends HecProduct>(
  product: P,
  badges: HecBadge[],
): P => ({
  ...product,
  c_badging: undefined,
  c_secondBadging: undefined,
  badges,
});

/** The spender tile's "{n} Added" badge; none at quantity 0. */
export const addedBadge = (qty: number, intl: IntlShape): HecBadge[] =>
  qty > 0 ? [{ text: intl.formatMessage(messages.added, { count: qty }) }] : [];
